import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskDirective } from 'ngx-mask';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';

import { TabsNavigationComponent } from './components/tabs-navigation/tabs-navigation.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { CCheckboxComponent } from './components/c-checkbox/c-checkbox.component';
import { OutsideClickDirective } from './directives/outside-click.directive';
import { LiberarManualDialogComponent } from './components/liberar-manual-dialog/liberar-manual-dialog.component';
import { CInputComponent } from './components/c-input/c-input.component';
import { ContratosFooterComponent } from './components/contratos-footer/contratos-footer.component';
import { DetailsFormComponent } from './components/details-form/details-form.component';
import { CRadioComponent } from './components/c-radio/c-radio.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { CDialogComponent } from './components/c-dialog/c-dialog.component';
import { PaginationFooterComponent } from './components/pagination-footer/pagination-footer.component';
import { DashFilterComponent } from './components/dash-filter/dash-filter.component';
import { HeaderListComponent } from './components/header-list/header-list.component';
import { CAnexoComponent } from './components/c-anexo/c-anexo.component';
import { CSelectComponent } from './components/c-select/c-select.component';
import { CInputLegacyComponent } from './components/c-input-legacy/c-input-legacy.component';
import { CRichTextComponent } from './components/c-rich-text/c-rich-text.component';
import { ModalContractVisualizeComponent } from './components/modal-contract-visualize/modal-contract-visualize.component';
import { BeneficiaryContractCardComponent } from './components/beneficiary-contract-card/beneficiary-contract-card.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { DetalhesLotesCardComponent } from './components/detalhes-lotes-card/detalhes-lotes-card.component';
import { LotsGroupDialogComponent } from './components/dialog-contracts/lots-group-dialog/lots-group-dialog.component';
import { DialogContractsComponent } from './components/dialog-contracts/dialog-contracts.component';
import { GenerateLotsDialogComponent } from './components/dialog-contracts/generate-lots-dialog/generate-lots-dialog.component';
import { ListContractsDialogComponent } from './components/dialog-contracts/list-contracts-dialog/list-contracts-dialog.component';
import { ContractCardDialogComponent } from './components/dialog-contracts/lots-group-dialog/contract-card-dialog/contract-card-dialog.component';
import { ListagemLotesComponent } from './components/listagem-lotes/listagem-lotes.component';
import { CardLotesComponent } from './components/card-lotes/card-lotes.component';
import { CardsContratosLotesComponent } from './components/detalhes-lotes/cards-contratos-lotes/cards-contratos-lotes.component';
import { IsAllowedDirective } from './directives/is-allowed.directive';
import { EmptyCardComponent } from './components/empty-card/empty-card.component';
import { CSelectMultiComponent } from './components/c-select-multi/c-select-multi.component';
import { OrderedHeaderListComponent } from './components/ordered-header-list/ordered-header-list.component';
import { CardManualBatchContractComponent } from './components/card-manual-batch-contract/card-manual-batch-contract.component';
import { CInputFilterComponent } from './components/c-input-filter/c-input-filter.component';
import { InputFilterPipe } from './pipes/inputFilter.pipe';
import { SystemDatePipe } from './pipes/system-date.pipe';
import { ScrollPaginationComponent } from './components/scroll-pagination/scroll-pagination.component';
import { ModalBatchEventLogComponent } from './components/modal-batch-event-log/modal-batch-event-log.component';
import { ModalTransferBatchMassCreateResultComponent } from './components/modal-transfer-batch-mass-create-result/modal-transfer-batch-mass-create-result.component';
import { NotificationComponent } from './components/notification/notification.component';
import { ListagemLotesRepasseComponent } from './components/listagem-lotes-repasse/listagem-lotes-repasse.component';
import { ListagemLotesFaturamentoComponent } from './components/listagem-lotes-faturamento/listagem-lotes-faturamento.component';
import { CardLotesRepasseComponent } from './components/card-lotes-repasse/card-lotes-repasse.component';
import { CardLotesFaturamentoComponent } from './components/card-lotes-faturamento/card-lotes-faturamento.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { KpiRowComponent } from './components/kpi-row/kpi-row.component';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';
import { PercentMaskDirective } from './masks/percent-mask';

@NgModule({
  declarations: [
    TabsNavigationComponent,
    SvgIconComponent,
    CCheckboxComponent,
    OutsideClickDirective,
    CInputComponent,
    ContratosFooterComponent,
    DetailsFormComponent,
    CRadioComponent,
    LoaderComponent,
    SkeletonComponent,
    DialogComponent,
    PaginationFooterComponent,
    CDialogComponent,
    DashFilterComponent,
    HeaderListComponent,
    CAnexoComponent,
    CSelectComponent,
    CInputLegacyComponent,
    CRichTextComponent,
    ModalContractVisualizeComponent,
    BeneficiaryContractCardComponent,
    DialogContractsComponent,
    GenerateLotsDialogComponent,
    ListContractsDialogComponent,
    LotsGroupDialogComponent,
    ContractCardDialogComponent,
    ListagemLotesComponent,
    CardLotesComponent,
    CardsContratosLotesComponent,
    DetalhesLotesCardComponent,
    IsAllowedDirective,
    EmptyCardComponent,
    CSelectMultiComponent,
    OrderedHeaderListComponent,
    CardManualBatchContractComponent,
    CInputFilterComponent,
    InputFilterPipe,
    SystemDatePipe,
    ScrollPaginationComponent,
    ModalBatchEventLogComponent,
    ModalTransferBatchMassCreateResultComponent,
    NotificationComponent,
    LiberarManualDialogComponent,
    ListagemLotesRepasseComponent,
    ListagemLotesFaturamentoComponent,
    CardLotesRepasseComponent,
    CardLotesFaturamentoComponent,
    StatusBadgeComponent,
    KpiRowComponent,
    FilterPanelComponent,
    PercentMaskDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    CKEditorModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule
  ],
  exports: [
    TabsNavigationComponent,
    SvgIconComponent,
    CCheckboxComponent,
    OutsideClickDirective,
    TabsNavigationComponent,
    CInputComponent,
    ContratosFooterComponent,
    DetailsFormComponent,
    CRadioComponent,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    LoaderComponent,
    SkeletonComponent,
    PaginationFooterComponent,
    CDialogComponent,
    DashFilterComponent,
    HeaderListComponent,
    CAnexoComponent,
    CSelectComponent,
    CInputLegacyComponent,
    CRichTextComponent,
    ModalContractVisualizeComponent,
    BeneficiaryContractCardComponent,
    DialogContractsComponent,
    GenerateLotsDialogComponent,
    ListContractsDialogComponent,
    LotsGroupDialogComponent,
    ContractCardDialogComponent,
    ListagemLotesComponent,
    CardLotesComponent,
    CardsContratosLotesComponent,
    DetalhesLotesCardComponent,
    MatTooltipModule,
    IsAllowedDirective,
    EmptyCardComponent,
    CSelectMultiComponent,
    OrderedHeaderListComponent,
    CardManualBatchContractComponent,
    CInputFilterComponent,
    ScrollPaginationComponent,
    ModalBatchEventLogComponent,
    ModalTransferBatchMassCreateResultComponent,
    NotificationComponent,
    ListagemLotesRepasseComponent,
    ListagemLotesFaturamentoComponent,
    CardLotesRepasseComponent,
    CardLotesFaturamentoComponent,
    StatusBadgeComponent,
    KpiRowComponent,
    FilterPanelComponent,
    PercentMaskDirective,
    SystemDatePipe
  ]
})
export class SharedModule {}
